const colors = {
  primary: {
    200: 'var(--color-primary-200)',
    150: 'var(--color-primary-150)',
    100: 'var(--color-primary-100)',
    80: 'var(--color-primary-80)',
    50: 'var(--color-primary-50)',
    30: 'var(--color-primary-30)',
    20: 'var(--color-primary-20)',
    10: 'var(--color-primary-10)',
  },
  tertiary: {
    200: 'var(--color-tertiary-200)',
    150: 'var(--color-tertiary-150)',
    100: 'var(--color-tertiary-100)',
    90: 'var(--color-tertiary-90)',
    80: 'var(--color-tertiary-80)',
    20: 'var(--color-tertiary-20)',
  },
  secondary: {
    150: 'var(--color-secondary-150)',
    100: 'var(--color-secondary-100)',
    50: 'var(--color-secondary-50)',
    10: 'var(--color-secondary-10)',
  },
  neutral: {
    black100: 'var(--color-neutral-black100)',
    black26: 'var(--color-neutral-black26)',
    white100: 'var(--color-neutral-white100)',
    background10: 'var(--color-neutral-background10)',
  },
  grays: {
    100: 'var(--color-grays-100)',
    90: 'var(--color-grays-90)',
    80: 'var(--color-grays-80)',
    70: 'var(--color-grays-70)',
    60: 'var(--color-grays-60)',
    50: 'var(--color-grays-50)',
    45: 'var(--color-grays-45)',
    40: 'var(--color-grays-40)',
    30: 'var(--color-grays-30)',
    20: 'var(--color-grays-20)',
    10: 'var(--color-grays-10)',
    5: 'var(--color-grays-5)',
  },
  success: {
    200: 'var(--color-success-200)',
    150: 'var(--color-success-150)',
    100: 'var(--color-success-100)',
    50: 'var(--color-success-50)',
    30: 'var(--color-success-30)',
    10: 'var(--color-success-10)',
    8: 'var(--color-success-8)',
  },
  error: {
    200: 'var(--color-error-200)',
    150: 'var(--color-error-150)',
    100: 'var(--color-error-100)',
    50: 'var(--color-error-50)',
    20: 'var(--color-error-20)',
    10: 'var(--color-error-10)',
  },
  warning: {
    200: 'var(--color-warning-200)',
    150: 'var(--color-warning-150)',
    100: 'var(--color-warning-100)',
    50: 'var(--color-warning-50)',
    10: 'var(--color-warning-10)',
    8: 'var(--color-warning-8)',
    5: 'var(--color-warning-5)',
  },
  helpAndSupport: {
    gray150: 'var(--color-helpAndSupport-gray150)',
    gray200: 'var(--color-helpAndSupport-gray200)',
    darkGray: 'var(--color-helpAndSupport-darkGray)',
  },
  decorative: {
    terraCotta: 'var(--color-decorative-terraCotta)',
    seaSerpent: 'var(--color-decorative-seaSerpent)',
    coolPurple: 'var(--color-decorative-coolPurple)',
    coolPurple10: 'var(--color-decorative-coolPurple10)',
    coolPurple20: 'var(--color-decorative-coolPurple20)',
    coolPurple100: 'var(--color-decorative-coolPurple100)',
    coolPurple150: 'var(--color-decorative-coolPurple150)',
    malachiteGreen: 'var(--color-decorative-malachiteGreen)',
    navel: 'var(--color-decorative-navel)',
    homeAlert: 'var(--color-decorative-homeAlert)',
    liveColor: 'var(--color-decorative-liveColor)',
    steelblue: {
      translucent: 'var(--color-decorative-steelblue-translucent)',
      solid: 'var(--color-decorative-steelblue-solid)',
    },
    green10: 'var(--color-decorative-green10)',
    orange10: 'var(--color-decorative-orange10)',
    red10: 'var(--color-decorative-red10)',
    purple10: 'var(--color-decorative-purple10)',
    splash: 'var(--color-decorative-splash)',
    Purple200: 'var(--color-decorative-Purple200)',
    bee: {
      150: 'var(--color-decorative-bee-150)',
      100: 'var(--color-decorative-bee-100)',
      50: 'var(--color-decorative-bee-50)',
      20: 'var(--color-decorative-bee-20)',
      10: 'var(--color-decorative-bee-10)',
    },
    bee100: 'var(--color-decorative-bee100)',
  },
  tag: {
    shade1: 'var(--color-tag-shade1)',
    shade2: 'var(--color-tag-shade2)',
  },
  lead: {
    subAgentLead: 'var(--color-lead-subAgentLead)',
  },
  magnet: {
    primary: {
      10: 'var(--color-magnet-primary-10)',
    },
  },
  slate: {
    100: 'var(--color-slate-100)',
  },
}

module.exports = colors
